"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./TextArea.scss");
var _excluded = ["id", "className", "elementLocator", "title", "name", "placeholder", "value", "resize", "valid", "touched"];
var Textarea = function Textarea(_ref) {
  var id = _ref.id,
    className = _ref.className,
    elementLocator = _ref.elementLocator,
    title = _ref.title,
    name = _ref.name,
    placeholder = _ref.placeholder,
    value = _ref.value,
    resize = _ref.resize,
    valid = _ref.valid,
    touched = _ref.touched,
    others = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  var classes = (0, _classnames.default)('textarea', className, {
    'validation-error': touched && !valid,
    success: touched && valid
  });
  return _react.default.createElement("textarea", (0, _extends2.default)({
    id: id,
    className: classes + " " + (resize ? '' : 'disable-resize'),
    name: name,
    title: title,
    placeholder: placeholder,
    defaultValue: value,
    value: value,
    resize: resize,
    "data-locator": elementLocator || "textarea-input-" + name + "-" + id
  }, others));
};
Textarea.defaultProps = {
  id: '',
  name: '',
  className: '',
  elementLocator: '',
  title: '',
  placeholder: '',
  value: '',
  resize: false,
  touched: false,
  valid: false
};
var _default = Textarea;
exports.default = _default;
module.exports = exports["default"];